.error-page {
  align-items: center;
  display: flex;
  flex: 1;
  left: 0;
  justify-content: center;
  height: 100%;
  position: absolute;
  top: 0;
  width: 100%;

  >* {
    align-items: center;
    justify-content: center;
  }

  :global(.wrapper):before,
  :global(.wrapper):after {
    display: none;
  }
}

.error-page__content {
  position: relative;
  text-align: center;
  z-index: 10;

  >h1:first-letter {
    text-transform: uppercase;
  }

  :global(.embed) & {
    h1 {
      font-size: var(--font__size-h3);
    }
  }

  a {
    color: var(--color__white);
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }

  :global(.light-contrast) & {
    color: var(--color__black);

    a {
      color: var(--color__black);
    }
  }

  @media screen and (max-height: 24px) {
    h1 {
      font-size: 10px;
      margin: 0;
    } 
  }
}

.error-page__dark {
  background-color: var(--color__black);
  color: var(--color__white);
}